import {Observable} from "rxjs";
import { common } from '@qwyk/models';
import { PageRequest } from '@qwyk/ui-standalone';
import { ShipmentPackage } from "./+state/shipment-packages.models";

export abstract class ShipmentPackagesServiceBase {
    public abstract getShipmentPackages(shipmentId: string, query: PageRequest): Observable<{ data: ShipmentPackage[]; meta: common.PaginationMeta }>;

    public abstract updateShipmentPackage(
        shipmentId: string,
        shipmentPackageId: number,
        changes: Partial<ShipmentPackage>
    ): Observable<ShipmentPackage>;
}
